import { baseApi } from '@/app/api'

import {
	FormSubmissionsQueryParams,
	HeatmapData,
	MeetingBookedData,
	MeetingData,
	MeetingDataQueryParams,
	MeetingsByMemberData,
} from '../types'

export enum ReportingEndPoints {
	getMeetingBookedData = 'getMeetingBookedData',
	getMeetingsForTeam = 'getMeetingsForTeam',
	getMeetingsForMember = 'getMeetingsForMember',
	getHeatmapData = 'getHeatmapData',
}

export const reportingApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		[ReportingEndPoints.getMeetingBookedData]: builder.query<
			MeetingBookedData[],
			FormSubmissionsQueryParams
		>({
			query: ({ datePreset, dateRange, additionalFilters }) => ({
				url: 'reporting/meetings/booked',
				method: 'POST',
				body: { datePreset, dateRange, additionalFilters },
			}),
			providesTags: (result, error, arg) => {
				const formIdsTag = arg.additionalFilters ? 'WithFilters' : 'NoFilters'
				return [{ type: 'GET_MEETINGS_BOOKED', id: formIdsTag }]
			},
		}),
		[ReportingEndPoints.getMeetingsForMember]: builder.query<
			MeetingsByMemberData[],
			MeetingDataQueryParams
		>({
			query: ({ datePreset, dateRange, granularity, memberIds }) => ({
				url: 'reporting/meetings/members',
				method: 'POST',
				body: { datePreset, dateRange, granularity, memberIds },
			}),
			providesTags: ['GET_MEETINGS_FOR_MEMBER'],
		}),
		[ReportingEndPoints.getMeetingsForTeam]: builder.query<
			MeetingData[],
			MeetingDataQueryParams
		>({
			query: ({ datePreset, dateRange, granularity }) => ({
				url: 'reporting/meetings/team',
				method: 'POST',
				body: { datePreset, dateRange, granularity },
			}),
			providesTags: ['GET_MEETINGS_FOR_TEAM'],
		}),
		[ReportingEndPoints.getHeatmapData]: builder.query<
			HeatmapData[],
			MeetingDataQueryParams
		>({
			query: ({ datePreset, dateRange, granularity }) => ({
				url: 'reporting/meetings/heatmap',
				method: 'POST',
				body: { datePreset, dateRange, granularity },
			}),
			providesTags: ['GET_HEATMAP_DATA'],
		}),
	}),
})

export const {
	useGetMeetingBookedDataQuery,
	useGetMeetingsForTeamQuery,
	useGetHeatmapDataQuery,
	useGetMeetingsForMemberQuery,
} = reportingApi
